// investorImages.ts
import winasa_bar from "../../assets/img/investorPool/Winasa_Ceramica_1.png";
import winasa_map from "../../assets/img/investorPool/Winasa_Ceramica_2.png";
import winasa_ship from "../../assets/img/investorPool/Winasa_Ceramica_3.png";
import winasa_country from "../../assets/img/investorPool/Winasa_Ceramica_country.png";
import winasa_buyers from "../../assets/img/investorPool/Winasa_Ceramica_buyers.png";

import apImpex_bar from "../../assets/img/investorPool/Asia_Pacific_Impex_1.png";
import apImpex_map from "../../assets/img/investorPool/Asia_Pacific_Impex_2.png";
import apImpex_ship from "../../assets/img/investorPool/Asia_Pacific_Impex_3.png";
import apImpex_country from "../../assets/img/investorPool/Asia_Pacific_Impex_country.png";
import apImpex_buyers from "../../assets/img/investorPool/Asia_Pacific_Impex_buyers.png";

import geonix_bar from "../../assets/img/investorPool/Geonix_1.png";
import geonix_map from "../../assets/img/investorPool/Geonix_2.png";
import geonix_ship from "../../assets/img/investorPool/Geonix_3.png";
import geonix_country from "../../assets/img/investorPool/Geonix_country.png";
import geonix_buyers from "../../assets/img/investorPool/Geonix_buyers.png";

import surya_bar from "../../assets/img/investorPool/Surya_1.png";
import surya_map from "../../assets/img/investorPool/Surya_2.png";
import surya_ship from "../../assets/img/investorPool/Surya_3.png";
import surya_country from "../../assets/img/investorPool/Surya_country.png";
import surya_buyers from "../../assets/img/investorPool/Surya_buyers.png";

export const investorImages = {
  winasa: {
    barChat: winasa_bar,
    map: winasa_map,
    shipmentPercentage: winasa_ship,
    exportByCountry: winasa_country,
    exportByBuyers: winasa_buyers,
  },
  apImpex: {
    barChat: apImpex_bar,
    map: apImpex_map,
    shipmentPercentage: apImpex_ship,
    exportByCountry: apImpex_country,
    exportByBuyers: apImpex_buyers,
  },
  geonix: {
    barChat: geonix_bar,
    map: geonix_map,
    shipmentPercentage: geonix_ship,
    exportByCountry: geonix_country,
    exportByBuyers: geonix_buyers,
  },
  surya: {
    barChat: surya_bar,
    map: surya_map,
    shipmentPercentage: surya_ship,
    exportByCountry: surya_country,
    exportByBuyers: surya_buyers,
  },
} as const;
